import { tv } from 'tailwind-variants';

export const buttonRecipe = tv({
  slots: {
    button:
      'group relative cursor-pointer select-none flex items-center gap-1 justify-center rounded-lg text-xs focus:outline-none',
    label: 'inline-flex items-center justify-center font-medium',
    prefix: '',
    suffix: '',
    loading:
      'absolute top-0 left-0 right-0 bottom-0 flex items-center justify-center rounded-lg text-brand-gray-10',
  },
  variants: {
    variant: {
      default: {
        button: [
          'bg-white',
          'dark:bg-brand-gray-15',
          'text-brand-gray-15',
          'dark:text-white',
          'active:bg-brand-gray-4',
          'dark:active:bg-brand-gray-16',
          'active:text-brand-gray-16',
          'dark:active:text-white',
          'dark:hover:bg-brand-gray-16',
          'shadow-brand-button',
          'dark:shadow-brand-button-shadow-contrast',
          'hover:shadow-brand-button-hover',
          'active:shadow-brand-button-active',
          'dark:active:shadow-brand-button-shadow-contrast-inset',
          'data-[pressed=true]:bg-brand-gray-4',
          'dark:data-[pressed=true]:bg-brand-gray-15',
          'data-[pressed=true]:text-brand-gray-16',
          'dark:data-[pressed=true]:text-white',
          'data-[pressed=true]:shadow-brand-button-active',
          'dark:data-[pressed=true]:shadow-brand-button-shadow-contrast-inset',
        ],
      },
      primary: {
        button: [
          'bg-brand-blue-11',
          'text-white',
          'active:text-white',
          'hover:bg-brand-blue-12',
          'active:bg-brand-blue-13',
          'data-[pressed=true]:bg-brand-blue-13',
          'shadow-brand-button-primary',
          'active:shadow-brand-button-primary-active',
          'data-[pressed=true]:shadow-brand-button-primary-active',
        ],
      },
      secondary: {
        button: [
          'bg-white',
          'dark:bg-brand-gray-15',
          'text-brand-gray-15',
          'dark:text-white',
          'active:bg-brand-gray-4',
          'dark:active:bg-brand-gray-16',
          'active:text-brand-gray-16',
          'dark:active:text-white',
          'dark:hover:bg-brand-gray-16',
          'shadow-brand-button',
          'dark:shadow-brand-button-shadow-contrast',
          'hover:shadow-brand-button-hover',
          'active:shadow-brand-button-active',
          'dark:active:shadow-brand-button-shadow-contrast-inset',
          'data-[pressed=true]:bg-brand-gray-4',
          'dark:data-[pressed=true]:bg-brand-gray-15',
          'data-[pressed=true]:text-brand-gray-16',
          'dark:data-[pressed=true]:text-white',
          'data-[pressed=true]:shadow-brand-button-active',
          'dark:data-[pressed=true]:shadow-brand-button-shadow-contrast-inset',
        ],
      },
      critical: {
        button: [
          'bg-brand-red-12',
          'text-white',
          'active:text-white',
          'hover:bg-brand-red-13',
          'active:bg-brand-red-14',
          'data-[pressed=true]:bg-brand-red-14',
          'data-[pressed=true]:shadow-brand-button-primary-critical-inset',
          'shadow-brand-button-primary-critical',
          'hover:shadow-brand-button-primary-critical-hover',
          'active:shadow-brand-button-primary-critical-inset',
        ],
      },
      magic: {
        button: [
          'bg-brand-purple-12',
          'text-white',
          'active:text-white',
          'hover:bg-brand-purple-13',
          'active:bg-brand-purple-14',
          'data-[pressed=true]:bg-brand-purple-14',
          'data-[pressed=true]:shadow-brand-button-magic-inset',
          'shadow-brand-button-magic',
          'hover:shadow-brand-button-magic-hover',
          'active:shadow-brand-button-magic-inset',
        ],
      },
      success: {
        button: [
          'bg-brand-green-12',
          'text-white',
          'active:text-white',
          'hover:bg-brand-green-13',
          'active:bg-brand-green-14',
          'data-[pressed=true]:bg-brand-green-14',
          'data-[pressed=true]:shadow-brand-button-primary-critical-inset',
          'shadow-brand-button-primary-success',
          'hover:shadow-brand-button-primary-success-hover',
          'active:shadow-brand-button-primary-success-inset',
        ],
      },
      contrast: {
        button: [
          'bg-brand-gray-15',
          'text-white',
          'active:text-white',
          'hover:bg-brand-gray-16',
          'active:bg-brand-gray-16',
          'data-[pressed=true]:bg-brand-gray-15',
          'data-[pressed=true]:shadow-brand-button-shadow-contrast-inset',
          'shadow-brand-button-shadow-contrast',
          'active:shadow-brand-button-shadow-contrast-inset',
          'dark:bg-white',
          'dark:text-brand-gray-15',
          'dark:active:bg-brand-gray-4',
          'dark:active:text-brand-gray-16',
          'dark:shadow-brand-button',
          'dark:hover:shadow-brand-button-hover',
          'dark:active:shadow-brand-button-active',
          'dark:data-[pressed=true]:bg-brand-gray-4',
          'dark:data-[pressed=true]:text-brand-gray-16',
          'dark:data-[pressed=true]:shadow-brand-button-active',
        ],
      },
      tertiary: {
        button: [
          'bg-transparent',
          'text-brand-text',
          'active:text-brand-text',
          'hover:bg-brand-black-alpha-5',
          'hover:dark:bg-brand-white-alpha-5',
          'active:bg-brand-black-alpha-7',
          'active:dark:bg-brand-white-alpha-7',
          'data-[pressed=true]:bg-brand-black-alpha-7',
          'data-[pressed=true]:dark:bg-brand-white-alpha-7',
        ],
      },
      subtle: {
        button: [
          'bg-brand-fill-tertiary',
          'text-brand-text',
          'active:text-brand-text',
          'hover:bg-brand-fill-tertiary-hover',
          'active:bg-brand-fill-tertiary-active',
          'data-[pressed=true]:bg-brand-fill-tertiary-active',
        ],
      },
      caution: {
        button: [
          'bg-brand-surface-caution',
          'text-brand-text',
          'active:text-brand-text',
          'hover:bg-brand-surface-caution-hover',
          'active:bg-brand-surface-caution-active',
          'data-[pressed=true]:bg-brand-surface-caution-active',
          'shadow-brand-button-caution',
          'hover:shadow-brand-button-caution',
          'active:shadow-brand-button-caution-active',
          'data-[pressed=true]:shadow-brand-button-caution-active',
        ],
      },
    },
    size: {
      sm: {
        button: 'h-6 px-2',
      },
      default: {
        button: 'h-7 px-3',
      },
      lg: {
        button: 'h-9 px-4',
      },
    },
    isIconOnly: {
      true: {},
      false: {},
    },
    isDisabled: {
      true: {
        button: [
          'disabled:bg-brand-black-alpha-9 dark:disabled:bg-brand-white-alpha-9 disabled:shadow-none disabled:text-white disabled:cursor-not-allowed',
        ],
        label: '',
      },
    },
    isLoading: {
      true: {
        button:
          'disabled:bg-brand-gray-6 dark:disabled:bg-brand-gray-14 disabled:shadow-none disabled:cursor-not-allowed',
        label: 'opacity-0',
        prefix: 'opacity-0',
        suffix: 'opacity-0',
      },
      false: {},
    },
  },
  compoundVariants: [
    {
      isIconOnly: true,
      size: 'sm',
      class: {
        button: 'w-6',
      },
    },
    {
      isIconOnly: true,
      size: 'default',
      class: {
        button: 'w-7',
      },
    },
    {
      isIconOnly: true,
      size: 'lg',
      class: {
        button: 'w-9',
      },
    },
    {
      isDisabled: false,
      variant: [
        'default',
        'primary',
        'secondary',
        'critical',
        'success',
        'contrast',
        'magic',
        'caution',
      ],
      class: {
        label:
          'group-active:translate-y-[0.0625rem] group-data-[pressed=true]:translate-y-[0.0625rem]',
        prefix:
          'group-active:translate-y-[0.0625rem] group-data-[pressed=true]:translate-y-[0.0625rem]',
        suffix:
          'group-active:translate-y-[0.0625rem] group-data-[pressed=true]:translate-y-[0.0625rem]',
      },
    },
  ],
  defaultVariants: {
    variant: 'default',
    size: 'default',
    isIconOnly: false,
    isDisabled: false,
    isLoading: false,
  },
});
